import chalk from 'chalk';

/**
 * Canonical "Agents: Early Access / WIP" banner shown on:
 *  - `mutagent --help` (top-level help hub)
 *  - `mutagent agents --help`
 *  - `mutagent agents <subcommand> --help` (list / get / create / update / delete)
 *
 * Keep this in ONE place so copy cannot drift between surfaces.
 * Mirrors the user-facing stance documented in:
 *   .claude/skills/mutagent-cli/SKILL.md → "Agents: Work In Progress"
 */
export const AGENTS_WIP_BANNER = `${chalk.yellow('Agents: Early Access / WIP')}
  ${chalk.bold('Agent optimization & evaluation are actively in development.')}
  ${chalk.dim('The Prompt path (single-shot LLM calls with output schemas) is production-ready.')}
  ${chalk.dim('For Agents (multi-turn / tool-calling), join early access:')}
  ${chalk.cyan('https://www.mutagent.io/agents-partnership')}
  ${chalk.dim('`mutagent agents ...` CRUD commands exist but optimization/eval are NOT ready.')}`;

/**
 * Compact one-liner variant for subcommand `--help` footers where the full
 * banner would be noisy. Always links to the same partnership URL so users
 * hitting any subcommand's help can see the WIP status.
 */
export const AGENTS_WIP_BANNER_SHORT = `${chalk.yellow('[Agents WIP]')} ${chalk.dim('CRUD only — optimization & evaluation in development.')} ${chalk.cyan('https://www.mutagent.io/agents-partnership')}`;
